import React from "react";
import CareMomentsExplainedScreen from "./CareMomentsExplainedScreen";

type Props = {
  onClickGoBack: () => void;
};

export default function CareMomentsExplainedActivity(props: Props) {
  return <CareMomentsExplainedScreen onClickGoBack={props.onClickGoBack} />;
}
